/**
 * Rocksoft MDM API 2.0
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RequestType = {
    ProfileList: 'ProfileList',
    ProvisioningProfileList: 'ProvisioningProfileList',
    RemoveProvisioningProfile: 'RemoveProvisioningProfile',
    CertificateList: 'CertificateList',
    InstalledApplicationList: 'InstalledApplicationList',
    DeviceLock: 'DeviceLock',
    Idle: 'Idle',
    DeviceInformation: 'DeviceInformation',
    SecurityInfo: 'SecurityInfo',
    ClearPasscode: 'ClearPasscode',
    EraseDevice: 'EraseDevice',
    Restrictions: 'Restrictions',
    InstallProfile: 'InstallProfile',
    RestartDevice: 'RestartDevice',
    ShutDownDevice: 'ShutDownDevice',
    RequestMirroring: 'RequestMirroring',
    UserList: 'UserList',
    EnableLostMode: 'EnableLostMode',
    DisableLostMode: 'DisableLostMode',
    PlayLostModeSound: 'PlayLostModeSound',
    RemoveProfile: 'RemoveProfile',
    DeviceLocation: 'DeviceLocation',
    InstallApplication: 'InstallApplication',
    InstallEnterpriseApplication: 'InstallEnterpriseApplication',
    InstallProvisioningProfile: 'InstallProvisioningProfile',
    ManagedApplicationConfiguration: 'ManagedApplicationConfiguration',
    ManagedApplicationAttributes: 'ManagedApplicationAttributes',
    ApplyRedemptionCode: 'ApplyRedemptionCode',
    ManagedApplicationList: 'ManagedApplicationList',
    RemoveApplication: 'RemoveApplication',
    ValidateApplications: 'ValidateApplications',
    ManagedMediaList: 'ManagedMediaList',
    Settings: 'Settings',
    ScheduleOsUpdate: 'ScheduleOSUpdate',
    ScheduleOsUpdateScan: 'ScheduleOSUpdateScan',
    AvailableOsUpdates: 'AvailableOSUpdates',
    OsUpdateStatus: 'OSUpdateStatus',
    DeviceConfigured: 'DeviceConfigured',
    ManagedApplicationFeedback: 'ManagedApplicationFeedback',
} as const;
export type RequestType = typeof RequestType[keyof typeof RequestType];

